<template>
  <div class="proposal__wrap">
    <div class="section shadow filter__wrap">
      <div class="flex">
        <el-form ref="elFormDom" inline :model="table.params" size="small">
          <el-form-item label="主题" prop="title">
            <el-input
              clearable
              v-model="table.params.title"
              placeholder="请输入"
              @keyup.enter.native.prevent="handleSearch"
            ></el-input>
          </el-form-item>
          <el-form-item label="企业名称" prop="company_id">
            <el-select
              v-model="table.params.company_id"
              size="mini"
              filterable
              clearable
              placeholder="请选择"
            >
              <el-option
                v-for="item in companyList_"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button
              type="primary"
              icon="el-icon-search"
              @click="handleSearch"
              >查询
            </el-button>
            <el-button icon="el-icon-refresh-right" @click="reset"
              >重置</el-button
            >
          </el-form-item>
        </el-form>
      </div>
      <el-row style="margin-top: 10px">
        <el-button size="small" type="primary" @click="toEdit"
          >添加招聘会</el-button
        >
      </el-row>
    </div>
    <!-- 表格 -->
    <div class="table__wrap">
      <VTable
        has-pagionation
        title=""
        addText="添加"
        indexLabel="序号"
        :field="field"
        :loading="table.loading"
        :data="table.data"
        :page="table.params.page"
        :pageSize="table.params.count"
        :total="table.total"
        :tree-props="{ children: 'children', hasChildren: 'has_child' }"
        :hasPagionation="true"
        :default-expand-all="true"
        :showOverflowTooltip="true"
        @handleSizeChange="handleSizeChange"
        @handleCurrentChange="handleCurrentChange"
      >
        <template v-slot:company_count="{ row }">
          <el-button type="text" @click="showcompanyDetails(row)"
            >{{ row.company_count }}家</el-button
          >
        </template>
        <template v-slot:start_day="{ row }">
          {{ row.start_day }}至{{ row.end_day }}
        </template>
        <template v-slot:job_count="{ row }">
          <el-button type="text" @click="showjobDetails(row)"
            >{{ row.job_count }}个</el-button
          >
        </template>
        <template v-slot:status="{ row }">
          {{ { 1: "开启", 2: "关闭" }[row.status] }}</template
        >
        <template v-slot:action="{ row }">
          <el-popconfirm
            title="确定开启吗？"
            @confirm="changeRow(row)"
            v-if="row.status == 2"
          >
            <el-button slot="reference" type="text">开启</el-button>
          </el-popconfirm>
          <el-popconfirm
            title="确定关闭吗？"
            @confirm="changeRow(row)"
            v-if="row.status == 1"
          >
            <el-button slot="reference" type="text">关闭</el-button>
          </el-popconfirm>

          <el-button type="text" @click="editRow(row)" style="margin-left: 10px"
            >修改</el-button
          >
        </template>
      </VTable>
    </div>

    <companydetail ref="companydetailRef" @refresh="getTable"></companydetail>
    <jobdetail ref="jobdetailRef" @refresh="getTable"></jobdetail>
    <edit ref="editRef" @refresh="getTable"></edit>
  </div>
</template>

<script>
import VTable from "@/components/VTable";
import companydetail from "./components/companydetail.vue";
import edit from "./components/edit.vue";
import jobdetail from "./components/jobdetail.vue";
import { mixinTable } from "@/mixins/table.js";
export default {
  name: "ReportList",
  mixins: [mixinTable],
  components: {
    VTable,
    companydetail,
    jobdetail,
    edit,
  },
  data() {
    return {
      companyList_: [],
      field: [
        { name: "title", label: "招聘会主题", hidden: false },
        { name: "start_day", label: "活动时间", hidden: false,width:"200px" },
        { name: "company_count", label: "参与企业数", hidden: false },
        { name: "job_count", label: "参与岗位数", hidden: false },
        { name: "read_times", label: "浏览人次", hidden: false },
        { name: "send_times", label: "投递人次", hidden: false },
        { name: "status", label: "状态", hidden: false },
        { name: "banner_title", label: "绑定轮播图", hidden: false },
        {
          name: "create_time",
          label: "创建时间",
          hidden: false,
          width: "160px",
        },
        { name: "action", label: "操作", width: "100px", hidden: false },
      ],
      table: {
        loading: false,
        params: {
          title: "",
          company_id: "",
          page: 1,
          count: 10,
        },
        data: [],
        total: 0,
      },
    };
  },
  created() {
    this.getCompanyList();
    this.getTable();
  },
  methods: {
    toEdit() {
      let dom = this.$refs.editRef;
      dom.toggle(true);
      dom = null;
    },
    editRow(row) {
      let dom = this.$refs.editRef;
      dom.toggle(true);
      dom.getDetail(row);
      dom = null;
    },
    getTable() {
      this.$http
        .get("/admin/fair/list", { params: this.table.params })
        .then((res) => {
          if (res.code === 1) {
            this.table.data = res.data.list;
            this.table.total = res.data.total;
            this.share_open_status = res.data.share_open_status;
            this.share_days = res.data.share_days;
          }
        });
    },
    // 重置查询条件
    reset() {
      this.$refs.elFormDom.resetFields();
      this.table.params.page = 1;
      this.getTable();
    },
    changeRow(row) {
      this.$http
        .post("/admin/fair/updateStatus", {
          status: row.status == 1 ? 2 : 1,
          id: row.id,
        })
        .then((res) => {
          if (res.code == 1) {
            this.$message.success("操作成功");
            this.getTable();
          }
        });
    },
    showcompanyDetails(row) {
      let dom = this.$refs.companydetailRef;
      dom.toggle(true);
      if (!!row.id) {
        dom.getDetail(row);
      }
      dom = null;
    },
    showjobDetails(row) {
      let dom = this.$refs.jobdetailRef;
      dom.toggle(true);
      if (!!row.id) {
        dom.getDetail(row);
      }
      dom = null;
    },
  },
};
</script>

<style scoped lang="scss">
.flex {
  display: flex;
}
.proposal__wrap {
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 20px;
  position: relative;

  .filter__wrap {
    padding: 10px;
    margin-bottom: 20px;
    display: flex;
    justify-content: space-between;
    flex-direction: column;
  }

  .table__wrap {
    flex: 1;
    padding: 0;
    box-sizing: border-box;
  }
}
.t {
  font-size: 14px;
  line-height: 1.5;
  cursor: pointer;
}
.justify-between {
  justify-content: space-between;
}
.m {
  margin: 0 5px 0 35px;
}
</style>